export default __webpack_public_path__ + "static/freerateupdate-c811f3ac4093c2b977b259882150e809.svg";